import React, { useState } from 'react';
import { FaCheck, FaTimes, FaUpload, FaImage } from 'react-icons/fa'; // Icons for check, X, upload, and image

const ImageSection = ({ title }) => {
    const [removeClicked, setRemoveClicked] = useState(false); // Track if Remove was clicked

    const sectionStyle = {
        display: 'inline-block',
        width: '80%',  // Adjust size of the image section
        padding: '20px',
        border: '1px solid rgba(0, 0, 0, .125)',
        borderRadius: '5px',
        position: 'relative',
        textAlign: 'center',
        backgroundColor: '#fff',
        marginBottom: '20px',  // Space between rows
    };

    const imageIconStyle = {
        fontSize: '100px',  // Large gray image icon
        color: 'gray',
        marginBottom: '15px',
    };

    const buttonWrapperStyle = {
        position: 'absolute',
        top: '-10px',
        right: '-50px', // Keep the original position for the "Remove" button
        display: 'flex',
        gap: '5px',   // Add space between buttons when they appear
    };

    const buttonStyle = {
        padding: '6px 12px',
        border: 'none',
        borderRadius: '4px',
        fontSize: '12px',
        cursor: 'pointer',
        fontWeight: 'bold',
    };

    const removeButtonStyle = {
        ...buttonStyle,
        backgroundColor: '#dc3545',
        color: 'white',
        position: 'absolute', // Original position of remove button
        top: '-10px',
        right: '-10px',
    };

    const confirmButtonStyle = {
        ...buttonStyle,
        backgroundColor: '#198754',
        color: 'white',
    };

    const cancelButtonStyle = {
        ...buttonStyle,
        backgroundColor: '#dc3545',
        color: 'white',
    };

    const uploadButtonStyle = {
        ...buttonStyle,
        backgroundColor: 'black',
        color: 'white',
        position: 'absolute',
        bottom: '-20px',  // Position at the bottom middle of the image box
        left: '50%',
        transform: 'translateX(-50%)',
    };

    const handleRemoveClick = () => {
        setRemoveClicked(true);
    };

    const handleCancelRemove = () => {
        setRemoveClicked(false); // Reset state if cancel
    };

    const handleDelete = () => {
        // Logic for deleting the image section goes here
        // console.log(`Deleted ${title}`);
    };

    return (
        <div style={sectionStyle}>
            <FaImage style={imageIconStyle} /> {/* Gray image icon */}
            {!removeClicked ? (
                <button style={removeButtonStyle} onClick={handleRemoveClick}>
                    Remove
                </button>
            ) : (
                <div style={buttonWrapperStyle}>
                    <button style={confirmButtonStyle} onClick={handleCancelRemove}>
                        <FaCheck />
                    </button>
                    <button style={cancelButtonStyle} onClick={handleDelete}>
                        <FaTimes />
                    </button>
                </div>
            )}
            <button style={uploadButtonStyle}>
                <FaUpload /> {/* Black upload image icon */}
            </button>
        </div>
    );
};

export default ImageSection;
